import * as React from 'react';
export const generateNumeralMarker = (id, link) => {
    var _a, _b;
    const numeral = (_b = (_a = link.properties) === null || _a === void 0 ? void 0 : _a.markerValue, (_b !== null && _b !== void 0 ? _b : 0));
    return (React.createElement("marker", { id: id, name: "check-circle", viewBox: "0 0 20 20", refX: "8", refY: "8", markerWidth: "8", markerHeight: "8", orient: "0" },
        React.createElement("g", null,
            React.createElement("circle", { cx: "8.032", cy: "7.955", r: "7.5" }),
            React.createElement("text", { x: "4", y: "12" }, numeral))));
};
